import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useRouteMatch } from "react-router-dom";
import { setPageClass, setUpHeader } from "../../store/features/slice-ui";
import PageHead from "../../components/PageHead";
import PageContent from "../../components/PageContent";
import DoctorsFilter from '../../components/Filters/DoctorsFilter';

const DocotrsFilterPage = () => {
  const dispatch = useDispatch();
  const match = useRouteMatch();
  useEffect(() => {
    dispatch(setPageClass("page-filter-doctor"));
    dispatch(setUpHeader({
      show: true,
      back: true, 
      profile: true,
      search: true
    }));
  }, [dispatch]);

  return (
    <>
      <PageHead 
        className="page-filter-doctor--page-head"
        title="Filter"
      />
      <PageContent className="page-filter-doctor--page-content">
        <DoctorsFilter 
          className="page-filter-doctor--content-wrapper pt-0" 
          pushAfterSubmit={`${match.url.indexOf("/discuss-patient") > -1 ? '/discuss-patient' : '/doctors'}/search`}
          filter={match.url.indexOf("/discuss-patient") > -1 ? 'dp' : 'doctors'}
        />
      </PageContent>
    </> 
    
  );
};

export default DocotrsFilterPage;
